import {
  BUDGET_CONSTANTS,
  DEFAULT_LOCALE
} from '@f-fertighaus/applications/Next/config/constants'

const formatPrice = (price: number) =>
  new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency: 'EUR'
  })
    .format(price)
    .replace(',00', '')

// This is a function taken from fertighaus repository. It's difficult to assure reliability of this computation
const calculateMonthlyRate = (totalPrice: number): number => {
  const monthlyInterestRate = BUDGET_CONSTANTS.yearlyInterestRate / 12
  const mortgageTermMonths = BUDGET_CONSTANTS.mortgageTermYears * 12
  const maxBorrowAmount =
    totalPrice +
    BUDGET_CONSTANTS.extraCosts * totalPrice -
    BUDGET_CONSTANTS.equity *
      (totalPrice + BUDGET_CONSTANTS.equity * totalPrice)

  return (
    (monthlyInterestRate *
      (1 + monthlyInterestRate) ** mortgageTermMonths *
      maxBorrowAmount) /
    ((1 + monthlyInterestRate) ** mortgageTermMonths - 1)
  )
}

export const PRICE = {
  formatPrice,
  calculateMonthlyRate
}
